import "core-js/modules/es6.function.name";
import isMeteorUser from "../boot/meteor/isMeteorUser.js";
import { Meteor } from 'meteor/meteor';
import { isOwner, isVerifiedOwner } from 'api/owners/rules';
import { seesAdminScreens, isSuperadmin, isSuperadminOnly } from 'api/core/roles';
import { startRouteFor } from 'src/functions/startRoute'; // meta atlas: the page wears Atlas for owners and admins (src/mixins/mixin-atlas-page.js), and a change between two
// such pages keeps the look on (no flash of the app's own ground)
// Owners must be verified before managing communities (D4). Legacy management pages are guarded in
// the UI only (D11): an unverified owner is sent to their dashboard. Fans and verified owners pass.

var requireManagingOwner = function requireManagingOwner(to, from, next) {
  isMeteorUser().then(function () {
    var user = Meteor.user();

    if (user && isOwner(user) && !isVerifiedOwner(user)) {
      next({
        name: 'ownerDashboard'
      });
    } else {
      next();
    }
  });
}; // pages of one's own (inbox, outbox): logged in only; others go to the welcome page (#391)


var requireLogin = function requireLogin(to, from, next) {
  isMeteorUser().then(function (response) {
    response && Meteor.user() ? next() : next({
      name: 'welcome'
    });
  });
}; // a visitor's pages (the welcome, log in, register, forgot password; #442): someone logged in goes to their own start,
// or with a community's invite (/register/:id) to that community's page


var visitorOnly = function visitorOnly(to, from, next) {
  isMeteorUser().then(function (response) {
    if (!response) next();else if (to.name === 'register' && to.params.id) next({
      name: 'communityDetail',
      params: {
        id: to.params.id
      }
    });else next(startRouteFor(Meteor.user()));
  });
}; // admin pages (/admin/...): admins only; others go to their own start page


var requireAdmin = function requireAdmin(to, from, next) {
  isMeteorUser().then(function (response) {
    if (!response) {
      next({
        name: 'welcome'
      });
    } else if (seesAdminScreens(Meteor.user())) {
      next();
    } else {
      next({
        name: 'home'
      });
    }
  });
};

var routes = [// {
//     path: '/',
//     component: () => import('pages/Index.vue')
// },
{
  path: '/',
  component: function component() {
    return import('layouts/MyLayout.vue');
  },
  beforeEnter: function beforeEnter(to, from, next) {
    isMeteorUser().then(function (response) {
      if (response) {
        next();
      } else {
        next();
      }
    });
  },
  children: [{
    path: '',
    name: 'home',
    props: true,
    // component: () => import('pages/MyCommunityPage.vue'),
    beforeEnter: function beforeEnter(to, from, next) {
      isMeteorUser().then(function (response) {
        // if true, continue, else redirect to Login page
        // response ? next() : next({ name: 'welcome' })
        // response ? (Meteor.user().profile.owner ? next({ name: 'myOwnedCommunities' }) : (Meteor.user().profile.subs.length > 0 ? next() : next({ name: 'myAreas' }))) : next({ name: 'welcome' })
        // response ? Meteor.user().profile.owner ? next({ name: 'myOwnedCommunities' }) : next() : next({ name: 'welcome' })
        if (response) {
          if (isSuperadminOnly(Meteor.user())) {
            next({
              name: 'adminMaintenance'
            });
          } else if (seesAdminScreens(Meteor.user())) {
            next({
              name: 'adminHome'
            });
          } else if (Meteor.user().profile.owner) {
            next({
              name: 'ownerDashboard'
            });
          } else {
            next({
              name: 'home2'
            });
          }
        } else {
          next({
            name: 'welcome'
          });
        }
      });
    }
  }, {
    path: 'home',
    name: 'home2',
    // the fan look for fans, Atlas for the others (mixin-fan-page, #339): either hands on without a flash
    meta: {
      fanLook: true,
      atlas: true
    },
    props: true,
    component: function component() {
      return import('pages/Home.vue');
    },
    beforeEnter: function beforeEnter(to, from, next) {
      isMeteorUser().then(function () {
        isSuperadminOnly(Meteor.user()) ? next({
          name: 'adminMaintenance'
        }) : next();
      });
    }
  }, {
    // the admin section starts at its home page (D70)
    path: 'admin',
    redirect: {
      name: 'adminHome'
    }
  }, {
    path: 'admin/home',
    name: 'adminHome',
    meta: {
      atlas: true
    },
    component: function component() {
      return import('pages/AdminHomePage.vue');
    },
    beforeEnter: requireAdmin
  }, {
    // an admin edits name and description (D71)
    path: 'admin/communities/:id/edit',
    name: 'adminCommunityEdit',
    meta: {
      atlas: true
    },
    props: function props(route) {
      return {
        id: route.params.id,
        mode: 'admin'
      };
    },
    component: function component() {
      return import('pages/CommunityEditPage.vue');
    },
    beforeEnter: requireAdmin
  }, {
    // was /admin (D70)
    path: 'admin/communities',
    name: 'adminCommunities',
    meta: {
      atlas: true
    },
    component: function component() {
      return import('pages/AdminCommunitiesPage.vue');
    },
    beforeEnter: requireAdmin
  }, {
    // was /users (all users); fans only since 24 Sep 2026
    path: 'admin/fans',
    name: 'adminFans',
    meta: {
      atlas: true
    },
    component: function component() {
      return import('pages/AdminFansPage.vue');
    },
    beforeEnter: requireAdmin
  }, // fan map (#104): admins only
  {
    path: 'admin/fan-map',
    name: 'adminFanMap',
    meta: {
      atlas: true
    },
    component: function component() {
      return import('pages/AdminFanMapPage.vue');
    },
    beforeEnter: requireAdmin
  }, // one community's area facts (#533): admins only
  {
    path: 'admin/area-facts/:landId',
    name: 'adminAreaFacts',
    meta: {
      atlas: true
    },
    props: true,
    component: function component() {
      return import('pages/AdminAreaFactsPage.vue');
    },
    beforeEnter: requireAdmin
  }, // a visitor's pages in the fan look (mixin-fan-page, #339), each a page of its own since #442 (was one wizard)
  {
    path: 'welcome',
    name: 'welcome',
    meta: {
      showToolbar: false,
      fanLook: true,
      visitor: true
    },
    component: function component() {
      return import('pages/Welcome.vue');
    },
    beforeEnter: visitorOnly
  }, {
    path: 'login',
    name: 'login',
    meta: {
      showToolbar: false,
      fanLook: true,
      visitor: true
    },
    component: function component() {
      return import('pages/LoginPage.vue');
    },
    beforeEnter: visitorOnly
  }, {
    // :id: a community's invite link (in e-mails and QR codes as /welcome/:id, redirected below)
    path: 'register/:id?',
    name: 'register',
    meta: {
      showToolbar: false,
      fanLook: true,
      visitor: true
    },
    component: function component() {
      return import('pages/RegisterPage.vue');
    },
    props: true,
    beforeEnter: visitorOnly
  }, {
    path: 'forgot-password',
    name: 'forgotPassword',
    meta: {
      showToolbar: false,
      fanLook: true,
      visitor: true
    },
    component: function component() {
      return import('pages/ForgotPasswordPage.vue');
    },
    beforeEnter: visitorOnly
  }, // editing the account (#462, was the header's dialog): in the visitor's frame under the app bar, in the fan
  // look or Atlas by role; without the participation strip (one job on the page: the user's review)
  {
    path: 'account',
    name: 'account',
    meta: {
      fanLook: true,
      atlas: true,
      noParticipationStrip: true
    },
    component: function component() {
      return import('pages/AccountPage.vue');
    },
    beforeEnter: requireLogin
  }, {
    path: 'welcome/:id',
    redirect: function redirect(to) {
      return {
        name: 'register',
        params: {
          id: to.params.id
        },
        query: to.query
      };
    }
  }, {
    // the token is taken out of the address before the app starts (boot/reset-token.js, #39); an old link
    // opened with the token still in the path also works
    path: 'reset-password/:token?',
    name: 'resetPassword',
    // the fan look (mixin-fan-page, #339): a visitor
    meta: {
      showToolbar: false,
      fanLook: true
    },
    component: function component() {
      return import('pages/ResetPasswordPage.vue');
    },
    props: true
  }, {
    path: 'community/:id',
    name: 'communityDetail',
    component: function component() {
      return import('pages/Community.vue');
    },
    meta: {
      fanLook: true,
      atlas: true
    },
    props: true
  }, {
    path: 'create-thread/:id',
    name: 'createThread',
    // the fan look for a fan who moderates, Atlas for an owner (mixin-fan-page, #340)
    meta: {
      fanLook: true,
      atlas: true
    },
    beforeEnter: requireManagingOwner,
    component: function component() {
      return import('pages/CreateThreadPage.vue');
    },
    props: true
  }, {
    path: 'edit-thread/:id',
    name: 'editThread',
    // the fan look for a fan who moderates, Atlas for an owner (mixin-fan-page, #340)
    meta: {
      fanLook: true,
      atlas: true
    },
    beforeEnter: requireManagingOwner,
    component: function component() {
      return import('pages/EditThreadPage.vue');
    },
    props: true
  }, {
    path: 'create-meeting/:id',
    name: 'createMeeting',
    // the fan look for a fan who moderates, Atlas for an owner (mixin-fan-page, #340)
    meta: {
      fanLook: true,
      atlas: true
    },
    beforeEnter: requireManagingOwner,
    component: function component() {
      return import('pages/CreateMeetingPage.vue');
    },
    props: true
  }, {
    path: 'send-invites/:id',
    name: 'sendInvites',
    // the fan look for a fan who moderates, Atlas for an owner (mixin-fan-page, #340)
    meta: {
      fanLook: true,
      atlas: true
    },
    beforeEnter: requireManagingOwner,
    component: function component() {
      return import('pages/SendInvitesPage.vue');
    },
    props: true
  }, {
    path: 'create-polis/:id',
    name: 'createPolis',
    // the fan look for a fan who moderates, Atlas for an owner (mixin-fan-page, #340)
    meta: {
      fanLook: true,
      atlas: true
    },
    beforeEnter: requireManagingOwner,
    component: function component() {
      return import('pages/CreatePolisPage.vue');
    },
    props: true
  }, {
    path: 'create-poll/:id',
    name: 'createPoll',
    // the fan look for a fan who moderates, Atlas for an owner (mixin-fan-page, #340)
    meta: {
      fanLook: true,
      atlas: true
    },
    beforeEnter: requireManagingOwner,
    component: function component() {
      return import('pages/CreatePollPage.vue');
    },
    props: true
  }, {
    path: 'create-pledge/:id',
    name: 'createPledge',
    // the fan look for a fan, Atlas for an owner (mixin-fan-page, #340)
    meta: {
      fanLook: true,
      atlas: true
    },
    beforeEnter: requireManagingOwner,
    component: function component() {
      return import('pages/CreatePledgePage.vue');
    },
    props: true
  }, {
    path: 'edit-pledge/:id',
    name: 'editPledge',
    // the fan look for a fan, Atlas for an owner (mixin-fan-page, #340)
    meta: {
      fanLook: true,
      atlas: true
    },
    beforeEnter: requireManagingOwner,
    component: function component() {
      return import('pages/EditPledgePage.vue');
    },
    props: true
  }, {
    path: 'add-treasure/:id',
    name: 'addTreasure',
    // the fan look for a fan, Atlas for an owner (mixin-fan-page, #340)
    meta: {
      fanLook: true,
      atlas: true
    },
    component: function component() {
      return import('pages/AddTreasurePage.vue');
    },
    props: true
  }, {
    path: 'my-areas',
    name: 'myAreas',
    meta: {
      fanLook: true,
      atlas: true
    },
    component: function component() {
      return import('pages/MyAeraPage.vue');
    }
  }, {
    path: 'create-message',
    name: 'createMessage',
    // the fan look for a fan, Atlas for an owner (mixin-fan-page, #340)
    meta: {
      fanLook: true,
      atlas: true
    },
    // owners must be verified first (D4, D11); fans pass
    beforeEnter: requireManagingOwner,
    component: function component() {
      return import('pages/CreateMessagePage.vue');
    },
    props: true
  }, {
    path: 'my-communities',
    name: 'myCommunities',
    meta: {
      fanLook: true,
      atlas: true
    },
    component: function component() {
      return import('pages/MyCommunityPage.vue');
    },
    beforeEnter: function beforeEnter(to, from, next) {
      isMeteorUser().then(function (response) {
        // if true, continue, else redirect to Login page
        // response ? next() : next({ name: 'welcome' })
        // response ? (Meteor.user().profile.owner ? next({ name: 'myOwnedCommunities' }) : (Meteor.user().profile.subs.length > 0 ? next() : next({ name: 'myAreas' }))) : next({ name: 'welcome' })
        // response ? Meteor.user().profile.owner ? next({ name: 'myOwnedCommunities' }) : next() : next({ name: 'welcome' })
        if (response) {
          if (Meteor.user().profile.owner) {
            next({
              name: 'ownerDashboard'
            });
          } else {
            next();
          }
        } else {
          next({
            name: 'welcome'
          });
        }
      });
    }
  }, {
    path: 'map',
    name: 'map',
    component: function component() {
      return import('pages/Map.vue');
    },
    props: true,
    meta: {
      fanLook: true,
      atlas: true
    }
  },
  /* { path: 'create-area', name: 'createMaatregel', component: () => import('pages/CreateAreaPage.vue') }, */
  {
    path: 'area/:id',
    name: 'area',
    meta: {
      fanLook: true,
      atlas: true
    },
    component: function component() {
      return import('pages/AreaPage.vue');
    }
  }, {
    path: 'add-area',
    name: 'addAreaPage',
    redirect: {
      name: 'createMaatregel',
      params: {
        mode: 'single'
      }
    }
  }, {
    path: 'moderator-requests',
    name: 'moderatorRequests',
    meta: {
      atlas: true
    },
    beforeEnter: requireManagingOwner,
    component: function component() {
      return import('pages/ModeratorRequestsPage.vue');
    }
  }, // the fan look, Atlas for an owner or admin (mixin-fan-page, #340)
  {
    path: 'info',
    name: 'info',
    meta: {
      fanLook: true,
      atlas: true
    },
    component: function component() {
      return import('pages/Info.vue');
    }
  }, {
    path: 'owner-register',
    name: 'ownerRegister',
    meta: {
      bareHeader: true,
      atlas: true
    },
    component: function component() {
      return import('pages/OwnerRegisterPage.vue');
    },
    beforeEnter: function beforeEnter(to, from, next) {
      isMeteorUser().then(function (response) {
        if (!response) {
          next();
        } else if (Meteor.user().profile.owner) {
          next({
            name: 'ownerDashboard'
          });
        } else {
          next({
            name: 'home2'
          });
        }
      });
    }
  }, {
    path: 'owner',
    name: 'ownerDashboard',
    meta: {
      atlas: true
    },
    component: function component() {
      return import('pages/OwnerDashboardPage.vue');
    },
    beforeEnter: function beforeEnter(to, from, next) {
      isMeteorUser().then(function (response) {
        if (!response) {
          next({
            name: 'welcome'
          });
        } else if (Meteor.user().profile.owner) {
          next();
        } else {
          next({
            name: 'home'
          });
        }
      });
    }
  }, {
    // the owner edits their own community (D71); unverified owners go to their dashboard (D4)
    path: 'owner/community/:id/edit',
    name: 'ownerCommunityEdit',
    meta: {
      atlas: true
    },
    props: function props(route) {
      return {
        id: route.params.id,
        mode: 'owner'
      };
    },
    component: function component() {
      return import('pages/CommunityEditPage.vue');
    },
    beforeEnter: requireManagingOwner
  }, {
    path: 'owner/community/new',
    name: 'ownerCommunityNew',
    meta: {
      atlas: true
    },
    component: function component() {
      return import('pages/OwnerCommunityNewPage.vue');
    },
    beforeEnter: function beforeEnter(to, from, next) {
      isMeteorUser().then(function (response) {
        if (!response) {
          next({
            name: 'welcome'
          });
        } else if (isVerifiedOwner(Meteor.user())) {
          next();
        } else {
          next({
            name: 'ownerDashboard'
          });
        }
      });
    }
  }, {
    path: 'admin/owners',
    name: 'adminOwners',
    component: function component() {
      return import('pages/AdminOwnersPage.vue');
    },
    meta: {
      atlas: true
    },
    beforeEnter: requireAdmin
  }, {
    path: 'post/:id',
    name: 'post',
    props: true,
    meta: {
      fanLook: true,
      atlas: true
    },
    component: function component() {
      return import('pages/PostPage.vue');
    }
  }, {
    path: 'meeting/:id',
    name: 'meeting',
    props: true,
    // the fan look for a fan, Atlas for an owner (mixin-fan-page, #340)
    meta: {
      fanLook: true,
      atlas: true
    },
    component: function component() {
      return import('pages/MeetingPage.vue');
    }
  }, {
    path: 'polis/:id',
    name: 'polis',
    // the fan look for a fan, Atlas for an owner (mixin-fan-page, #340)
    meta: {
      fanLook: true,
      atlas: true
    },
    props: true,
    component: function component() {
      return import('pages/PolisPage.vue');
    }
  }, {
    path: 'poll/:id',
    name: 'poll',
    // the fan look for a fan, Atlas for an owner (mixin-fan-page, #340)
    meta: {
      fanLook: true,
      atlas: true
    },
    props: true,
    component: function component() {
      return import('pages/PollPage.vue');
    }
  }, {
    path: 'pledge/:id',
    name: 'pledge',
    // the fan look for a fan, Atlas for an owner (mixin-fan-page, #340)
    meta: {
      fanLook: true,
      atlas: true
    },
    props: true,
    component: function component() {
      return import('pages/PledgePage.vue');
    }
  }, {
    path: 'outbox',
    name: 'outbox',
    meta: {
      atlas: true
    },
    component: function component() {
      return import('pages/OutboxPage.vue');
    },
    beforeEnter: requireLogin
  }, {
    path: 'inbox',
    name: 'inbox',
    // the fan look for a fan, Atlas for an owner or admin (mixin-fan-page, #340)
    meta: {
      fanLook: true,
      atlas: true
    },
    component: function component() {
      return import('pages/InboxPage.vue');
    },
    beforeEnter: requireLogin
  }, {
    path: 'mailer',
    name: 'mailer',
    meta: {
      atlas: true
    },
    component: function component() {
      return import('pages/MailerPage.vue');
    }
  }, {
    path: 'score-settings',
    name: 'scoreSettings',
    meta: {
      atlas: true
    },
    component: function component() {
      return import('pages/ScoreSettingsPage.vue');
    }
  }, {
    path: 'admin/maintenance',
    name: 'adminMaintenance',
    meta: {
      atlas: true
    },
    component: function component() {
      return import('pages/AdminMaintenancePage.vue');
    },
    beforeEnter: function beforeEnter(to, from, next) {
      isMeteorUser().then(function (response) {
        if (!response) {
          next({
            name: 'welcome'
          });
        } else if (isSuperadmin(Meteor.user())) {
          next();
        } else {
          next({
            name: 'home'
          });
        }
      });
    }
  }, {
    path: 'email-templates',
    name: 'emailTemplates',
    meta: {
      atlas: true
    },
    component: function component() {
      return import('pages/EmailTemplatesPage.vue');
    }
  }, {
    path: 'edit-email-template/:id',
    name: 'editEmailTemplate',
    meta: {
      atlas: true
    },
    component: function component() {
      return import('pages/EditEmailTemplate.vue');
    },
    props: true
  }, {
    path: 'message/:id',
    name: 'message',
    // the fan look for a fan, Atlas for an owner or admin (mixin-fan-page, #340)
    meta: {
      fanLook: true,
      atlas: true
    },
    component: function component() {
      return import('pages/Message.vue');
    },
    props: true
  }]
}, {
  path: '/survey',
  component: function component() {
    return import('layouts/SurveyLayout.vue');
  },
  children: [{
    path: 'polis/:id/:user',
    name: 'polisExt',
    // the fan look: opened from outside the app (mixin-fan-page, #340)
    meta: {
      fanLook: true
    },
    component: function component() {
      return import('pages/PolisExtPage.vue');
    },
    props: true
  }, {
    path: 'redirect/:id/:route',
    name: 'redirect',
    component: function component() {
      return import('pages/RedirectPage.vue');
    },
    props: true
  }, {
    path: 'create-area/:mode',
    name: 'createMaatregel',
    props: true,
    meta: {
      fanLook: true
    },
    component: function component() {
      return import('pages/CreateAreaPage.vue');
    }
  }, {
    path: 'funding',
    name: 'funding',
    props: true,
    component: function component() {
      return import('pages/FundingPage.vue');
    },
    beforeEnter: function beforeEnter(to, from, next) {
      isMeteorUser().then(function (response) {
        if (response) {
          if (Meteor.user().profile.owner) {
            next({
              name: 'ownerDashboard'
            });
          } else {
            next();
          }
        } else {
          next({
            name: 'welcome'
          });
        }
      });
    }
  } // {
  //     path: 'create-area',
  //     name: 'createMaatregel',
  //     component: () => import('pages/CreateAreaPage.vue')
  // },
  ]
}]; // dev only: the shared parts in every state (#335; the ui-matrix route ui-parts walks it)

if (process.env.DEV) {
  routes.push({
    path: '/dev/parts',
    name: 'devParts',
    component: function component() {
      return import('pages/dev/UiPartsPage.vue');
    }
  });
} // Always leave this as last one


if (process.env.MODE !== 'ssr') {
  routes.push({
    path: '*',
    component: function component() {
      return import('pages/Error404.vue');
    }
  });
}

export default routes;